<template>
	<BarAbstract>
		<div id="TopBar">
			<MenuItem hotkey="ALT-D" path="/devices"><span class="Hotkey">D</span>evices</MenuItem> |
			<MenuItem hotkey="ALT-F" path="/flow"><span class="Hotkey">F</span>low</MenuItem>  |
			<MenuItem hotkey="ALT-I" path="/insights"><span class="Hotkey">I</span>nsights</MenuItem>  |
			<MenuItem hotkey="ALT-S" path="/settings"><span class="Hotkey">S</span>ettings</MenuItem> 
			<span id="selectedUser" v-if="selectedUser" @click="onHomeys">[{{selectedUser.firstname}}]</span>
			<span id="selectedHomey" v-if="selectedHomey" @click="onHomeys">{{selectedHomey}}</span>
		</div>
	</BarAbstract>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
	import { Getter, Action } from 'vuex-class';
	import BarAbstract from '../BarAbstract';
	import MenuItem from './MenuItem';

	@Component({
		components: {
			BarAbstract,
			MenuItem,
		},
	})
	export default class TopBar extends BarAbstract {
		@Getter('api/homey/selectedName') selectedHomey;
		@Getter('api/user') selectedUser;
		
    	mounted() {
        	this.addKeyboardListener('ALT-H', this.onHomeys, 'Change Homeys');
        	this.addKeyboardListener('?', this.onHelp);
        	super.mounted();
    	}
    	
    	destroyed() {
        	super.destroyed();
    	}
    	
    	onHomeys() {
        	this.$router.push('/homeys');
    	}
    	
    	onHelp() {
        	this.$router.push('/help');
    	}
	}
</script>

<style lang="scss" scoped>
#TopBar {
}
#selectedHomey, #selectedUser {
    float: right;
    margin-left: 14px;
}
</style>